module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/bnr_wedding_movie-fa555edd4f9c7e1810167f615e4a7e6d.jpg";